import React from "react";

import Sesion from "../components/commons/sesion";

export default function Help() {
  return (
    <div className={"Drawer"}>
      <Sesion screen={"Help"} />
    </div>
  );
}
